module.exports = __webpack_public_path__ + "images/help/icon-twr36-f450c1d2bd31eb70d3902340dd0937c4.png";